import { service } from '@ember/service';
import { camelize } from '@ember/string';

import { pluralize } from '@warp-drive/utilities/string';
import { didCancel, task, timeout } from 'ember-concurrency';
import BaseValidator from 'ember-cp-validations/validators/base';

import { getRecordType } from 'umg-ember-backend/utils/get-record-type';

export default BaseValidator.extend({
  // Services
  fetch: service(),

  // Validate
  async validate(value, options, model, attribute) {
    try {
      let result = await this.searchRecord.perform(model, attribute, value);

      if (result && result.id !== model.id) {
        return this.createErrorMessage('unique', value, options);
      }

      return true;
    } catch (error) {
      if (!didCancel(error)) {
        throw error;
      }
    }
  },

  // Tasks
  searchRecord: task(function* (model, attribute, value) {
    let requestName = camelize(pluralize(getRecordType(model)));
    let filter = {};
    filter[attribute] = value;

    if (!value) {
      return null;
    }

    yield timeout(500);

    let result = yield this.fetch.request(`/${requestName}`, {
      data: {
        filter,
      },
    });

    return result[requestName][0];
  }).restartable(),
});
